<template>
  <div id="page-wrap" v-if="loggedIn">
    Success
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TransactionStatusweb',
  computed: {
    ...mapGetters(['loggedIn'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TransactionStatusWeb.vue